import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { useParams } from 'react-router-dom'
import { StudentInfoForProfile } from './StudentInfoForProfile'
import { GradeInMonth } from '../GradeManagement/GradeInMonth'
import { CollegeListForProfile } from './CollegeListForProfile'
import { CoursesProfile } from './CoursesProfile'
import { ScoreTable } from '../GoalQuestions/ScoreTable'
import { ActivitiesProfile } from './ActivitiesProfile'
import { AwardsProfile } from './AwardsProfile'
import { BookList } from '../BookList/BookList'
import './Student911CollegeProfile.css'

const Student911CollegeProfile = ({ studentId: propStudentId }) => {
	const { user } = useAuth()
	const { studentId: urlStudentId, id } = useParams()
	const studentId = propStudentId || urlStudentId || id || user?.id
	const componentRef = useRef()

	const removeBorderClasses = () => {
		const elements = document.querySelectorAll('.border.border-3.border-primary')
		const studentInfoBox = document.getElementById('student-info-box')
		const studentInfoPrint = document.getElementById('student-info-print')

		if (studentInfoBox) studentInfoBox.style.display = 'none'
		if (studentInfoPrint) studentInfoPrint.style.display = 'block'

		elements.forEach((element) => {
			element.classList.add('border-hidden')
			element.classList.remove('border', 'border-3', 'border-primary')
		})
	}

	const restoreBorderClasses = () => {
		const elements = document.querySelectorAll('.border-hidden')
		const studentInfoBox = document.getElementById('student-info-box')
		const studentInfoPrint = document.getElementById('student-info-print')

		if (studentInfoBox) studentInfoBox.style.display = 'block'
		if (studentInfoPrint) studentInfoPrint.style.display = 'none'

		elements.forEach((element) => {
			element.classList.add('border', 'border-3', 'border-primary')
			element.classList.remove('border-hidden')
		})
	}

	const handlePrint = useReactToPrint({
		content: () => {
			removeBorderClasses()
			return componentRef.current
		},
		documentTitle: `College-Profile-${studentId}`,
		onAfterPrint: () => {
			restoreBorderClasses()
		}
	})

	if (!studentId) {
		return (
			<div className="text-center p-5">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Loading...</span>
				</div>
			</div>
		)
	}

	return (
		<div className="container-fluid">
			{/* Student Info Box with Back and Print buttons - Screen version */}
			<div id="student-info-box">
				<StudentInfoForProfile studentId={studentId} handlePrint={handlePrint} isProfile={true} />
			</div>

			<div className="card wish-card" ref={componentRef}>
				{/* Student Info - Print version */}
				<div id="student-info-print" style={{ display: 'none' }}>
					<StudentInfoForProfile studentId={studentId} handlePrint={handlePrint} isProfile={true} isPrint={true} />
				</div>

				<div className="card-body p-0">
					<div className="page-break">
						<CollegeListForProfile studentId={studentId} />
					</div>

					<span className="border border-3 border-primary"></span>

					<div className="page-break">
						<GradeInMonth studentId={studentId} classId={user?.class} isStudent={true} isProfile={true} />
					</div>

					<span className="border border-3 border-primary"></span>

					<div className="page-break">
						<CoursesProfile studentId={studentId} />
					</div>

					<span className="border border-3 border-primary"></span>

					<div className="page-break">
						<ScoreTable slug={studentId} isProfile={true} isStudent={true} />
					</div>

					<span className="border border-3 border-primary"></span>

					<div className="page-break">
						<ActivitiesProfile studentId={studentId} />
					</div>

					<span className="border border-3 border-primary"></span>

					<div className="page-break">
						<AwardsProfile studentId={studentId} />
					</div>

					<span className="border border-3 border-primary"></span>

					<div className="page-break">
						<BookList slug={studentId} isProfile={true} />
					</div>
				</div>
			</div>
		</div>
	)
}

export { Student911CollegeProfile }
